// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"ca1c83e5","248":"2c0649ac","439":"0de74102","448":"f5414efc","507":"f9d29030","582":"6d2a39a5","637":"83f343e6","739":"12557ca5","740":"00fd7a73","797":"8877ea5b","873":"b02a08ff","906":"36fd8c21","921":"22a1414b","940":"ebc15de4","969":"10dbb7f4"}[chunkId] + ".chunk.js";
};